import { Timestamp } from 'firebase/firestore';

/**
 * Renders a report's submission timestamp for display.
 *
 * This exists because the value used to be interpolated into a template string,
 * where `Date` was stringified implicitly. Rendered as a React child instead, a
 * `Date` object throws ("Objects are not valid as a React child"), so the
 * conversion has to be explicit. `String(date)` reproduces the previous output
 * exactly — this change is about escaping, not about reformatting dates.
 *
 * The parameter is `unknown` rather than `Timestamp` on purpose. `reports`
 * accepts unauthenticated writes and `fetchMeetingReports` casts rather than
 * parses, so the declared type is a claim about this field, not a guarantee.
 * A stored string, number, or map would make `.toDate()` throw and take the
 * reported-meetings screen down with it.
 */
export const formatReportDate = (dateSubmitted: unknown): string => {
  if (dateSubmitted instanceof Timestamp) {
    return String(dateSubmitted.toDate());
  }
  if (dateSubmitted instanceof Date) return String(dateSubmitted);
  // Not a timestamp at all. Say so rather than rendering a value that reads as
  // a real submission date — a reviewer acts on this field.
  return '(unknown date)';
};
